import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class AccountbankService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('accountbanks/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('accountbanks/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('accountbanks/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('accountbanks/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('accountbanks/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('accountbanks/delete', val_id);
  }

  allTypeAccount(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('finance/typeaccount', val_params);
  }
}
